import * as React from "react";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { setCurrentStep } from "../Stepper/stepperSlice";
import { useDispatch } from "react-redux";
import NavbarStepper from "../Stepper/NavBarStepper";
import { useParams } from "react-router-dom";
import { useInstallReplacementSmartNodeMutation,useGetIMSSmartnodeQuery, useAddChangeLogMutation } from "../../api/apiSlice";
import { useEffect } from "react";
import { showSuccess, showError } from "../../../Global/notifications/notificationsSlice";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useEditJobCardMutation } from "../../api/apiSlice";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useStepperStateRestoration } from "../useStepperStateRestoration";

export default function QRCodeScanReplace() {
  // Stepper state restoration
  useStepperStateRestoration();

  const [
    editJobCard, 
    {
      isSuccess: iseditJobCardSuccess,
      isError: iseditJobCardError,
      error: editJobCardError
    }
  ] = useEditJobCardMutation();


  const [
    installReplacementSmartnode,
    {
      isSuccess: installReplacementSmartnodeSuccess,
      isError: isinstallReplacementSmartnodeError,
      error: installReplacementSmartnodeError,
    },
  ] = useInstallReplacementSmartNodeMutation();

  const [
    addChangeLog,
    {
      isSuccess: addChangeLogSuccess,
      isError: isaddChangeLogError,
      error: addChangeLogError,
    },
  ] = useAddChangeLogMutation();


  const [qrCodeData, setQRCodeData] = React.useState(null);
  const [isNodeExists, setIsNodeExists] = React.useState(false);

  let { job_card_reference_id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();


 useEffect(() => { dispatch(setCurrentStep(5)); }, []);

 const { data: smartnode, isSuccess: isGetSmartnodeSuccess, isError: isGetSmartnodeError, error: getSmartNodeError } = useGetIMSSmartnodeQuery(
    qrCodeData ? { serial_number: qrCodeData.serial_number, imsi_number: qrCodeData.imsi_number } : skipToken
  );
  useEffect(() => {
    if ( installReplacementSmartnodeSuccess && qrCodeData ) {
      const { serial_number } = qrCodeData;
      const body = {
        serial_number:serial_number,
        change:"Installed as a replacement device, QE to approve",
      };
      addChangeLog({ body: body });
    }
  }, [installReplacementSmartnodeSuccess, job_card_reference_id, qrCodeData]);


  useEffect(() => {
    if ( addChangeLogSuccess  ) {
      const body = {
        state: "DET",
        reference_id: job_card_reference_id,
      };
      editJobCard({ body: body });
      setIsNodeExists(true)
    }
  }, [addChangeLogSuccess]);

  useEffect(() => {
    if (isGetSmartnodeSuccess && qrCodeData && isNodeExists==false) {
      setIsNodeExists(true)
      const { serial_number, imsi_number } = qrCodeData;
      const body = {
        
        serial_number: serial_number,
        reference_id: job_card_reference_id,
        imsi_number: imsi_number,
       
      };
      installReplacementSmartnode({ body: body });
    }
   
  }, [qrCodeData, isGetSmartnodeSuccess]);

  useEffect(() => {
    if (iseditJobCardSuccess &&  qrCodeData) {
      setIsNodeExists(true)
      navigate(`/installer/${job_card_reference_id}/${qrCodeData.serial_number}/${qrCodeData.imsi_number}/details`);
    }
   
  }, [iseditJobCardSuccess]);


  useEffect(() => {
    if (iseditJobCardError) {
      dispatch(showError(editJobCardError.data.error_message));
    }
   
  }, [iseditJobCardError, editJobCardError, dispatch, isNodeExists]);

  return (
    <>
      <NavbarStepper />

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 100px)", backgroundColor: "#000", px: 2 }}>
        {/* Viewfinder */}
        <Box sx={{ position: "relative", width: "85vw", height: "85vw", mb: 3 }}>
          {/* Corner brackets */}
          <Box sx={{ position: "absolute", top: 0, left: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderTopLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", top: 0, right: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderTopRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, left: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderBottomLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, right: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderBottomRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />

          <Box sx={{ width: "100%", height: "100%", overflow: "hidden", "& section": { height: "100% !important", paddingTop: "0 !important" }, "& section > div": { paddingTop: "0 !important", height: "100% !important", position: "relative !important" }, "& video": { objectFit: "cover !important", position: "static !important", width: "100% !important", height: "100% !important" } }}>
            <QrReader
              constraints={{ facingMode: "environment" }}
              onResult={(result, error) => {
                if (result && !qrCodeData) {
                  const qr_code_data = extractDataFromUrl(result.text);
                  setQRCodeData(qr_code_data);
                }
              }}
            />
          </Box>
        </Box>

        <Typography sx={{ color: "rgba(255,255,255,0.8)", textAlign: "center", fontSize: "0.95rem" }}>
          Scan QR Code of the replacement device being installed.
        </Typography>
      </Box>
    </>
  );
}

function extractDataFromUrl(url) {
  const urlParts = url.split("/");
  if (urlParts.length < 7) {
    throw new Error(`Invalid URL format: Current Part length${urlParts.length}`);
  }
  return {
    serial_number: urlParts[5],
    imsi_number: urlParts[6],
  };
}
